import { TLlMachineAvailabilityDayWiseKPIInfo } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const LL_MACHINE_AVAILABILITY_TABLE_MODEL = {
  createModel: function (
    headers: { key: string; displayName: string }[],
    data: TLlMachineAvailabilityDayWiseKPIInfo['machineWiseAvailability'],
  ) {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: headers.map((item) => ({
          type: 'TEXT_CELL',
          text: item.displayName,
          widthInPx: 200,
        })),
      },
      (rowItem) => ({
        type: 'ROW',
        rowItem,
        cells: headers.map((x) => ({
          type: 'TEXT_CELL',
          text: rowItem[x.key] ?? '- -',
          widthInPx: 200,
        })),
      }),
    );
  },
};
